import {makeStyles} from "@material-ui/core/styles";
import { colors } from "../../../shared/colors";

const useStyles = makeStyles( theme => ({
    icon: {
        color: colors.magellanSkyBlue,
        marginLeft: 20
    },
    tooltip: ({tooltipStyle}) => ({
        ...tooltipStyle
    })
}));

export default useStyles;